import script from "./MyInfoPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyInfoPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyInfoPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__